export default __webpack_public_path__ + "static/media/project-scoring.659ab61b.svg";